import { MISSION_AREAS } from "./mission-areas";

// FIREBASE REMOTE CONFIG CONSTANTS
export const FEATURED_JOB_SET = 3;

// JOB SEARCH CONSTANTS
export const FETCH_JOBS_LIMIT = 5;
export const MESSAGE_LOAD_LIMIT = 30;

// JOB POSTING CONSTANTS
export const JOB_POSTING_ISSUES = {
  options: [
    { value: 0, label: "Posting has expired" },
    { value: 1, label: "Link doesn't work" },
    { value: 2, label: "Description is incorrect" },
    { value: 3, label: "Other (please describe)" },
  ],
};

// HEADLINE
export const FIRST_NAME = {
  type: "text",
  label: "First name",
  placeholder: "Lara",
};
export const LAST_NAME = {
  type: "text",
  label: "Last name",
  placeholder: "Okimura",
};
export const PHOTO = {
  type: "image-picker",
  prompt: 'Smile and say, "One Work!" Your profile photo goes here.',
};
export const PRONOUNS = {
  type: "drop-down",
  prompt: "What pronouns would you like people to use when they refer to you?",
  placeholder: "Select an option",
  label: "Pronouns",
  options: [
    { value: 1, label: "he/him/his" },
    { value: 2, label: "she/her/hers" },
    { value: 3, label: "they/them/theirs" },
  ],
};
export const JOB_TITLE = {
  type: "text",
  label: "Job title",
  placeholder: "Sales Associate, Operations Manager, etc.",
};
export const URL = {
  type: "text",
  label: "External link",
  placeholder: "https://acme.com/careers?job=123",
};
export const MISSION_AREA = {
  type: "drop-down",
  placeholder: "Select an option",
  options: MISSION_AREAS.map((missionArea) => {
    return { value: missionArea.value, label: missionArea.name };
  }),
};

// MISSION
export const PERSONAL_MISSION = {
  type: "textarea",
  prompt:
    "What is your personal mission in life? What is your purpose or 'why'?",
  placeholder:
    "To build technology that enables humanity to reach the stars...",
};
export const COMPANY_MISSION = {
  type: "textarea",
  prompt: "What is the team's mission?",
  placeholder:
    "To build technology that enables humanity to reach the stars...",
};
export const MISSION_SIGNIFICANCE = {
  type: "textarea",
  prompt: "Why is your mission important to you? How did you discover it?",
  placeholder:
    "I believe the next wave of explorers will venture beyond our planet, and I want to do my part to help us reach our potential...",
};
export const MISSION_SIGNIFICANCE_J = {
  type: "textarea",
  prompt: "Why is the team's mission important?",
  placeholder: "We were inspired by the explorers who came before us...",
};

// CAREER
export const CAREER_GOALS = {
  type: "textarea",
  prompt:
    "What are your career goals? Maybe it's a skill you'd like to master, a type of work you'd like to be doing, or a quality of life you'd like to reach.",
  placeholder:
    "I would love to spend more of my time mentoring up and coming engineering talent...",
};
export const JOB_DESCRIPTION = {
  type: "textarea",
  prompt: "Describe a typical day in this job.",
  placeholder:
    "Focus on the core details of the job here. Treat it like a conversation starter — one or two paragraphs is plenty.",
};

// KNOWLEDGE
export const SKILLS = {
  type: "textarea-autocomplete",
  prompt:
    "Share your top strengths with the community and what you've accomplished with each of them.",
  placeholder: [
    "Marketing, JavaScript, etc.",
    "Describe what you've accomplished with this strength.",
  ],
  indexName: "skills",
  options: [
    { value: "1", label: "I can do it with guidance" },
    { value: "2", label: "I can do it independently" },
    { value: "3", label: "I can teach it to others" },
  ],
};
export const SKILLS_J = {
  type: "textarea-autocomplete",
  prompt: "What skills are required for this job?",
  placeholder: ["Marketing, JavaScript, etc.", ""],
  indexName: "skills",
  options: [
    { value: "1", label: "Can do it with guidance" },
    { value: "2", label: "Can do it independently" },
    { value: "3", label: "Can teach it to others" },
  ],
};
export const EDUCATION = {
  type: "drop-down",
  prompt:
    "Capture your formal education here. That might be a high school diploma, college degree, or certificate program — whatever you believe is most relevant.",
  placeholder: ["Select an option", "Provide a short description"],
  options: [
    { value: 1, label: "High school diploma or GED" },
    { value: 2, label: "Associate degree" },
    { value: 3, label: "Bachelor's degree" },
    { value: 4, label: "Master's degree" },
    { value: 5, label: "Doctorate" },
    { value: 6, label: "J.D. degree" },
    { value: 7, label: "Trade school" },
    { value: 8, label: "Bootcamp" },
    { value: 9, label: "Certificate" },
    { value: 10, label: "Course" },
  ],
};

// WORK ENVIRONMENT
export const LOCATION = {
  type: "text",
  prompt: "Where would you like to work from?",
  placeholder: "Yachats, OR, USA",
};
export const COMPANY_SIZE = {
  type: "checkboxes",
  prompt: "How big of a company would you like to work for?",
  options: [
    { value: "1", label: "Small" },
    { value: "2", label: "Medium" },
    { value: "3", label: "Large" },
    { value: "4", label: "Very large" },
  ],
};
export const OFFICE_TYPE = {
  type: "slider",
  prompt: "Do you prefer to work in an office or work remotely?",
  placeholder: 4,
  label: ["Work remotely", "Work onsite"],
};
export const LAYOUT = {
  type: "slider",
  prompt:
    "Do you work better in an open office layout or one that's a bit more closed off, like a private desk or office?",
  placeholder: 4,
  label: ["Open office", "Enclosed office"],
};
export const ACTIVITY_LEVEL = {
  type: "slider",
  prompt:
    "Do you prefer spending most of the day at a desk or most of the day on the move?",
  placeholder: 4,
  label: ["Stationary", "Active"],
};
export const NOISE_LEVEL = {
  type: "slider",
  prompt: "How much background noise do you like having around while you work?",
  placeholder: 4,
  label: ["Absolute quiet", "Lots of noise"],
};

// CULTURE
export const VALUES = {
  type: "chips-autocomplete",
  prompt: "What do you consider to be your core values?",
  placeholder: "Kindness, inclusion, candor, etc.",
  indexName: "company-values",
};
export const MINORITY_REPRESENTATION = {
  type: "drop-down",
  placeholder: "Select an option",
  prompt:
    "At your ideal company, what percentage of the workforce would you like to be people of color, LGBT+, or other minority group?",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "Less than 25%" },
    { value: 3, label: "At least 25%" },
    { value: 4, label: "At least 50%" },
    { value: 5, label: "At least 75%" },
    { value: 6, label: "100%" },
  ],
};
export const MINORITY_REPRESENTATION_J = {
  type: "drop-down",
  placeholder: "Select an option",
  prompt:
    "What percentage of the workforce are people of color, LGBT+, or other minority group?",
  options: [
    { value: 1, label: "Less than 25%" },
    { value: 2, label: "At least 25%" },
    { value: 3, label: "At least 50%" },
    { value: 4, label: "At least 75%" },
    { value: 5, label: "100%" },
  ],
};
export const FEMALE_REPRESENTATION = {
  type: "drop-down",
  placeholder: "Select an option",
  prompt:
    "At your ideal company, what percentage of the workforce would you like to be female?",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "Less than 25%" },
    { value: 3, label: "At least 25%" },
    { value: 4, label: "At least 50%" },
    { value: 5, label: "At least 75%" },
    { value: 6, label: "100%" },
  ],
};
export const FEMALE_REPRESENTATION_J = {
  type: "drop-down",
  placeholder: "Select an option",
  prompt: "What percentage of the workforce are female?",
  options: [
    { value: 1, label: "Less than 25%" },
    { value: 2, label: "At least 25%" },
    { value: 3, label: "At least 50%" },
    { value: 4, label: "At least 75%" },
    { value: 5, label: "100%" },
  ],
};
export const DRESS_CODE = {
  type: "drop-down",
  placeholder: "Select an option",
  prompt: "What would you like the dress code to be?",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "Casual" },
    { value: 3, label: "Business casual" },
    { value: 4, label: "Business professional" },
    { value: 5, label: "Business formal" },
  ],
};
export const DRESS_CODE_J = {
  type: "drop-down",
  placeholder: "Select an option",
  prompt: "What is the dress code?",
  options: [
    { value: 1, label: "Casual" },
    { value: 2, label: "Business casual" },
    { value: 3, label: "Business professional" },
    { value: 4, label: "Business formal" },
  ],
};

// TOTAL REWARDS
export const SALARY = {
  type: "drop-down",
  placeholder: "Select an option",
  prompt: "What is your target salary?",
  options: [
    { value: 1, label: "$30,000+" },
    { value: 2, label: "$40,000+" },
    { value: 3, label: "$50,000+" },
    { value: 4, label: "$60,000+" },
    { value: 5, label: "$70,000+" },
    { value: 6, label: "$80,000+" },
    { value: 7, label: "$90,000+" },
    { value: 8, label: "$100,000+" },
    { value: 9, label: "$110,000+" },
    { value: 10, label: "$120,000+" },
    { value: 11, label: "$130,000+" },
    { value: 12, label: "$140,000+" },
    { value: 13, label: "$150,000+" },
  ],
};
export const TIME_OFF = {
  type: "drop-down",
  prompt: "How much paid time off are you looking for each year?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "At least one week" },
    { value: 3, label: "At least two weeks" },
    { value: 4, label: "At least three weeks" },
    { value: 5, label: "At least four weeks" },
    { value: 6, label: "Unlimited paid time off" },
  ],
};
export const TIME_OFF_J = {
  type: "drop-down",
  prompt: "How much paid time off do you offer?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "None" },
    { value: 2, label: "At least one week" },
    { value: 3, label: "At least two weeks" },
    { value: 4, label: "At least three weeks" },
    { value: 5, label: "At least four weeks" },
    { value: 6, label: "Unlimited paid time off" },
  ],
};
export const HEALTH_INSURANCE = {
  type: "drop-down",
  prompt: "What level of health insurance coverage are you looking for?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "Partially covered" },
    { value: 3, label: "Fully covered" },
  ],
};
export const HEALTH_INSURANCE_J = {
  type: "drop-down",
  prompt: "What level of health insurance coverage do you offer?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "None" },
    { value: 2, label: "Partially covered" },
    { value: 3, label: "Fully covered" },
  ],
};
export const DENTAL_INSURANCE = {
  type: "drop-down",
  prompt: "What level of dental insurance coverage are you looking for?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "Partially covered" },
    { value: 3, label: "Fully covered" },
  ],
};
export const DENTAL_INSURANCE_J = {
  type: "drop-down",
  prompt: "What level of dental insurance coverage do you offer?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "None" },
    { value: 2, label: "Partially covered" },
    { value: 3, label: "Fully covered" },
  ],
};
export const VISION_INSURANCE = {
  type: "drop-down",
  prompt: "What level of vision insurance coverage are you looking for?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "Partially covered" },
    { value: 3, label: "Fully covered" },
  ],
};
export const VISION_INSURANCE_J = {
  type: "drop-down",
  prompt: "What level of vision insurance coverage do you offer?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "None" },
    { value: 2, label: "Partially covered" },
    { value: 3, label: "Fully covered" },
  ],
};
export const RETIREMENT_PLAN = {
  type: "drop-down",
  prompt: "What kind of employer retirement plan are you looking for?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "Offered" },
    { value: 3, label: "Offered with matching contribution" },
  ],
};
export const RETIREMENT_PLAN_J = {
  type: "drop-down",
  prompt: "What kind of employer retirement plan do you offer?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "None" },
    { value: 2, label: "Offered" },
    { value: 3, label: "Offered with matching contribution" },
  ],
};
export const MATERNITY_LEAVE = {
  type: "drop-down",
  label: "Maternity leave",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "At least one month" },
    { value: 3, label: "At least three months" },
    { value: 4, label: "At least six months" },
  ],
  placeholder: "Select an option",
};
export const MATERNITY_LEAVE_J = {
  type: "drop-down",
  label: "Maternity leave",
  options: [
    { value: 1, label: "None" },
    { value: 2, label: "At least one month" },
    { value: 3, label: "At least three months" },
    { value: 4, label: "At least six months" },
  ],
  placeholder: "Select an option",
};
export const PATERNITY_LEAVE = {
  type: "drop-down",
  label: "Paternity leave",
  options: [
    { value: 1, label: "No preference" },
    { value: 2, label: "At least one month" },
    { value: 3, label: "At least three months" },
    { value: 4, label: "At least six months" },
  ],
  placeholder: "Select an option",
};
export const PATERNITY_LEAVE_J = {
  type: "drop-down",
  label: "Paternity leave",
  options: [
    { value: 1, label: "None" },
    { value: 2, label: "At least one month" },
    { value: 3, label: "At least three months" },
    { value: 4, label: "At least six months" },
  ],
  placeholder: "Select an option",
};

// CAREER DEVELOPMENT
export const TUITION_REIMBURSEMENT = {
  type: "drop-down",
  prompt:
    "Are you looking for a tuition reimbursement benefit? This is when an employer helps you pay for continuing education in a field relevant to the company.",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "Offered" },
    { value: 2, label: "No preference" },
  ],
};
export const TUITION_REIMBURSEMENT_J = {
  type: "drop-down",
  prompt: "Do you offer tuition reimbursement?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "Offered" },
    { value: 2, label: "Not offered" },
  ],
};
export const JOB_TRAINING = {
  type: "drop-down",
  prompt:
    "Are you looking for job training beyond onboarding or on-the-job training? Some examples would be training to advance beyond your current role or to broaden your skills.",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "Offered" },
    { value: 2, label: "No preference" },
  ],
};
export const JOB_TRAINING_J = {
  type: "drop-down",
  prompt: "Do you offer job training beyond onboarding or on-the-job training?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "Offered" },
    { value: 2, label: "Not offered" },
  ],
};
export const LEADERSHIP_DEVELOPMENT = {
  type: "drop-down",
  prompt:
    "Are you specifically looking for a leadership development program, i.e. training designed to equip you with the skills to lead teams of people?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "Offered" },
    { value: 2, label: "No preference" },
  ],
};
export const LEADERSHIP_DEVELOPMENT_J = {
  type: "drop-down",
  prompt: "Do you offer a leadership development program?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "Offered" },
    { value: 2, label: "Not offered" },
  ],
};

// VISION
export const VISION = {
  type: "textarea",
  prompt:
    "Imagine the ideal day at work. Describe it in as much detail as you'd like.",
  placeholder:
    "My favorite part of the day is when I'm designing, so I'd love to be able to find a quiet nook at the office where I can focus independently on my design work...",
};

// STRUCTURE
export const WAGE_STRUCTURE = {
  type: "drop-down",
  prompt: "How do you prefer to be paid?",
  placeholder: "Select an option",
  options: [
    { value: 1, label: "Hourly" },
    { value: 2, label: "Salary" },
    { value: 3, label: "Contract" },
    { value: 4, label: "Commission" },
  ],
};
export const WEEKLY_HOURS = {
  type: "number",
  prompt: "How many hours per week would you like to work?",
  placeholder: 40,
};
export const SCHEDULE = {
  type: "slider",
  prompt: "Do you prefer flexible or fixed hours?",
  placeholder: 4,
  label: ["Fixed hours", "Flexible hours"],
};
export const LABOR_TYPE = {
  type: "slider",
  prompt: "Do you prefer manual labor or knowledge work?",
  placeholder: 4,
  label: ["Manual labor", "Knowledge work"],
};
export const SHIFT = {
  type: "checkboxes",
  prompt: "Which shifts would you like to work?",
  options: [
    { value: "1", label: "First shift" },
    { value: "2", label: "Second shift" },
    { value: "3", label: "Third shift" },
  ],
};
export const TRAVEL = {
  type: "slider",
  prompt: "Would you like to travel as part of your job?",
  placeholder: 4,
  label: ["Never", "Frequently"],
};
export const PERSPECTIVE = {
  type: "slider",
  prompt:
    "Do you prefer detail-oriented work or big picture work? Sometimes you'll hear this referred to as tactics versus strategy.",
  placeholder: 4,
  label: ["Big picture", "Detail-oriented"],
};
export const UNCERTAINTY = {
  type: "slider",
  prompt: "Do you prefer your tasks to be open-ended or well-defined?",
  placeholder: 4,
  label: ["Open-ended tasks", "Well-defined tasks"],
};
export const VARIETY = {
  type: "slider",
  prompt:
    "Do you prefer having similar work each day or different work on a regular basis?",
  placeholder: 4,
  label: ["Low variety", "High variety"],
};
export const CUSTOMER_INTERACTION = {
  type: "slider",
  prompt: "How often would you like to interact with customers?",
  placeholder: 4,
  label: ["Rarely", "Frequently"],
};
export const CREATIVITY = {
  type: "slider",
  prompt:
    "Do you prefer a job that requires a lot of creativity or none at all?",
  placeholder: 4,
  label: ["No creativity required", "Creativity required"],
};

// LEADERSHIP
export const AUTONOMY = {
  type: "slider",
  prompt: "Do you prefer having autonomy or taking direction?",
  placeholder: 4,
  label: ["Autonomy", "Direction"],
};
export const ROLE = {
  type: "slider",
  prompt: "Would you rather be a team lead or a team member?",
  placeholder: 4,
  label: ["Team lead", "Team member"],
};
export const LEADER = {
  type: "chips-autocomplete",
  prompt:
    "How would you describe your ideal leader and their leadership style?",
  placeholder: "Consistent, open-minded, supportive, etc.",
  indexName: "people-descriptors",
};

// TEAM
export const COLLABORATION = {
  type: "slider",
  prompt:
    "Do you prefer to spend most of your time working independently or working together with someone?",
  placeholder: 4,
  label: ["Work independently", "Work together"],
};
export const TEAM_MEMBERS = {
  type: "chips-autocomplete",
  prompt: "How would you describe your ideal team members?",
  placeholder: "Helpful, goofy, ambitious, etc.",
  indexName: "people-descriptors",
};
export const RELATIONSHIP = {
  type: "slider",
  prompt:
    "Do you prefer building friendships with other team members or keeping it professional?",
  placeholder: 4,
  label: ["Friendship", "Professional"],
};

// JOB POSTING CONSTANTS
export const FREE_JOB_POSTING = 0;
export const PREMIUM_JOB_POSTING = 1;
export const POSTING_TYPE = {
  placeholder: "Select an option",
  options: [
    { value: 0, label: "Starter • $0" },
    { value: 1, label: "Premium • $149" },
  ],
};
export const MAXIMUM_APPLICANTS = 5;

// APPLICANT CONSTANTS
export const STATUS_NEW = 1;

// COMPARISON CONSTANTS
export const FIELD_WEIGHTS = {
  companySize: { section: 0.2, overall: 0.03 },
  officeType: { section: 0.25, overall: 0.03 },
  layout: { section: 0.2, overall: 0.02 },
  activityLevel: { section: 0.2, overall: 0.03 },
  noiseLevel: { section: 0.15, overall: 0.02 },

  minorityRepresentation: { section: 0.3, overall: 0.02 },
  femaleRepresentation: { section: 0.3, overall: 0.02 },
  dressCode: { section: 0.4, overall: 0.03 },

  jobTraining: { section: 0.5, overall: 0.05 },
  leadershipDevelopment: { section: 0.3, overall: 0.03 },
  tuitionReimbursement: { section: 0.2, overall: 0.03 },

  salary: { section: 0.3, overall: 0.05 },
  timeOff: { section: 0.25, overall: 0.05 },
  healthInsurance: { section: 0.1, overall: 0.03 },
  dentalInsurance: { section: 0.1, overall: 0.03 },
  visionInsurance: { section: 0.05, overall: 0.02 },
  retirementPlan: { section: 0.1, overall: 0.03 },
  paternityLeave: { section: 0.05, overall: 0.02 },
  maternityLeave: { section: 0.05, overall: 0.02 },

  collaboration: { section: 1, overall: 0.03 },

  role: { section: 0.5, overall: 0.03 },
  autonomy: { section: 0.5, overall: 0.04 },

  wageStructure: { section: 0.05, overall: 0.01 },
  weeklyHours: { section: 0.05, overall: 0.02 },
  shift: { section: 0.05, overall: 0.02 },
  schedule: { section: 0.15, overall: 0.05 },
  laborType: { section: 0.12, overall: 0.04 },
  travel: { section: 0.08, overall: 0.03 },
  uncertainty: { section: 0.12, overall: 0.04 },
  variety: { section: 0.12, overall: 0.04 },
  perspective: { section: 0.08, overall: 0.03 },
  customerInteraction: { section: 0.1, overall: 0.03 },
  creativity: { section: 0.08, overall: 0.03 },
};
export const MATCH_THRESHOLDS = {
  workEnvironment: { great: 0.75, okay: 0.5, neutral: 3 },
  culture: { great: 0.75, okay: 0.5, neutral: 2 },
  careerDevelopment: { great: 0.75, okay: 0.5, neutral: 2 },
  totalBenefits: { great: 0.75, okay: 0.5, neutral: 4 },
  team: { great: 0.8, okay: 0.6, neutral: 1 },
  leadership: { great: 0.8, okay: 0.6, neutral: 1 },
  structure: { great: 0.8, okay: 0.6, neutral: 1 },
};
